<div class="flex flex-col h-screen bg-[#f0f0f0]">
  <app-navbar class="print:hidden"></app-navbar>
  <div class="relative flex flex-1 h-0">
    <div
      class="md:block hidden z-20 shadow print:hidden"
      [ngClass]="isNavDrawerOpen() ? 'basis-56' : 'basis-16'"
    >
      <app-navigation-drawer
        [modalOpen]="showAgreementModal()"
      ></app-navigation-drawer>
    </div>
    <div class="flex-1 w-0 h-full relative print:h-auto print:overflow-visible">
      <div
        id="printable-container"
        class="h-full overflow-y-auto md:scrollbar-thin print:h-auto print:overflow-visible"
      >
        <app-campaign-banner *ngIf="isHomePage"></app-campaign-banner>
        <div class="px-6">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
</div>
@if (showAgreementModal()) {
  <app-charity-agreement-modal
    (closeModal)="onModalClose()"
  ></app-charity-agreement-modal>
}
<app-custom-toast></app-custom-toast>
